"use strict";

angular.module('PatientApp').factory('ExperimentService', ['VueEventTransmitter', 'VuexStore', function (VueEventTransmitter, VuexStore) {
  return {
    getVariation: function getVariation(name, obj) {
      return VuexStore.dispatch('getVariation', {
        name: name,
        obj: obj
      });
    },
    isExperimentLoaded: function isExperimentLoaded(name) {
      return VuexStore.dispatch('isExperimentLoaded', name);
    },
    getExperimentData: function getExperimentData(name) {
      return VuexStore.dispatch('getExperimentData', name);
    },
    sendStart: function sendStart(name, obj) {
      return VuexStore.dispatch('sendStart', {
        name: name,
        obj: obj
      });
    },
    sendSuccess: function sendSuccess(name, obj) {
      return VuexStore.dispatch('sendSuccess', {
        name: name,
        obj: obj
      });
    },
    sendFailure: function sendFailure(name, obj) {
      return VuexStore.dispatch('sendFailure', {
        name: name,
        obj: obj
      });
    },
    waitForExperimentsToLoad: function waitForExperimentsToLoad(state) {
      return VuexStore.dispatch('waitForExperimentsToLoad', state);
    }
  };
}]);